import { API_URL } from '../../config/constants';
import { toast } from 'react-toastify';

export const getPeopleByCountry = async (userName, passwd, filter) => {
    try {
        const request = new Request(API_URL + "/v2/getPeopleByCountry", {
            method: 'POST',
            body: JSON.stringify({
                username: userName,
                password: passwd,
                filter: filter
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        if (response.status !== 200 && response.code !== 200) throw response;
        const json = await response.json();
        return json;
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}

export const uploadExcellDataSet = data => {
    let countryData = [];
    let total = 0;
    for (let i = 0; i < data.length; i++) {
        total += parseInt(data[i].personas, 10);
    }
    countryData = [...data];
    countryData.push({ country_name: "Total", personas: total });
    let excellData = {
        columns: [{
            label: "País",
            value: "country_name"
        }, {
            label: "Visitantes",
            value: "personas"
        }],
        data: countryData ? countryData : [],
        key: "country_data"
    };
    return excellData;
}


export const loadData = async (sessionData, filter) => {
    try {
        let responseCountry = await getPeopleByCountry(sessionData.userName, sessionData.passwd, filter);
        let excellData = uploadExcellDataSet(responseCountry.result.data);
        return { data: responseCountry.result.data, excellData: excellData, total: responseCountry.result.total };
    } catch (err) {
        console.error(err);
        toast("Produciuse un erro ao obter os datos. Intenteo de novo máis tarde", { className: "toast-error", autoClose: 3500 });
    }
}



// WEBPACK FOOTER //
// ./src/controllers/results/peopleByCountry.js